  (function () {
    var BOX_KEY = 'hfa_sample_box';
    var VAR_KEY = 'hfa_sample_variants';

    function readVarMap() {
      try { var v = JSON.parse(localStorage.getItem(VAR_KEY) || '{}'); return (v && typeof v === 'object') ? v : {}; }
      catch (e) { return {}; }
    }
    function writeVarMap(m) { try { localStorage.setItem(VAR_KEY, JSON.stringify(m)); } catch (e) {} }

    /* (1a) Record handle -> variantId whenever a sample button is clicked.
       Capture phase so it runs before the box's own (bubble) add handler. */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sample-handle][data-sample-variant]');
      if (!btn) return;
      var v = btn.getAttribute('data-sample-variant');
      var h = btn.getAttribute('data-sample-handle');
      if (!v || !h) return;
      var m = readVarMap();
      if (m[h] !== v) { m[h] = v; writeVarMap(m); }
    }, true);

    /* (1b) Intercept the box's Checkout and build the cart from real
       per-floor variants. Capture + stopImmediatePropagation prevents the
       box's original (generic-variant) checkout from running. */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sb-checkout]');
      if (!btn) return;
      e.preventDefault();
      e.stopImmediatePropagation();

      var box;
      try { box = JSON.parse(localStorage.getItem(BOX_KEY) || '[]'); } catch (_) { box = []; }
      if (!Array.isArray(box) || !box.length) return;

      var vmap = readVarMap();
      var root = document.querySelector('sample-box.hfa-sb');
      var generic = root ? root.getAttribute('data-sample-variant') : '';

      var label = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Preparing checkout…';

      var items = box.map(function (s) {
        var vid = s.variantId || vmap[s.handle] || generic;
        return {
          id: Number(vid),
          quantity: 1,
          properties: { 'Sample of': s.title, 'Handle': s.handle, 'SKU': s.sku || '' }
        };
      }).filter(function (it) { return it.id && !isNaN(it.id); });

      if (!items.length) { btn.disabled = false; btn.textContent = label; return; }

      fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          });
        })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () {
          return fetch('/cart/update.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { order_type: 'sample-order', sample_count: String(box.length) } })
          });
        })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = label;
          if (window.HFASampleBox && window.HFASampleBox.open) window.HFASampleBox.open();
        });
    }, true);

    /* (2) + (8) both need the product data (window.HFA_PDP_SAMPLE). */
    function hfaRun() {
      var d = window.HFA_PDP_SAMPLE;
      if (!d || !d.handle) return;

      /* (2) Inject the "Add free sample" pill on a floor product page —
         only when the floor has its own $0 sample variant. */
      if (d.variant) {
        // pre-seed the variant map so checkout works even if the button is
        // clicked before its own capture handler has run
        var pm = readVarMap();
        if (pm[d.handle] !== d.variant) { pm[d.handle] = d.variant; writeVarMap(pm); }

        var injectPDP = function () {
          if (document.querySelector('.hfa-sample-btn--pdp')) return true;
          var host = document.querySelector('.product-form-buttons:not(.related-accessory-form)') ||
                     document.querySelector('product-form-component:not([data-section-id^="complementary-accessories"])');
          if (!host) return false;
          var wrap = document.createElement('div');
          wrap.className = 'hfa-sample-pdp-wrap';
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'hfa-sample-btn hfa-sample-btn--pdp';
          btn.setAttribute('data-sample-handle', d.handle);
          btn.setAttribute('data-sample-title', d.title);
          btn.setAttribute('data-sample-image', d.image);
          btn.setAttribute('data-sample-sku', d.sku || '');
          btn.setAttribute('data-sample-variant', d.variant);
          btn.setAttribute('data-label-default', 'Add free sample');
          btn.innerHTML =
            '<span class="hfa-sample-btn__plus" aria-hidden="true">+</span>' +
            '<svg class="hfa-sample-btn__check" width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 13l4 4L19 7" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
            '<span data-sample-label>Add free sample</span>';
          wrap.appendChild(btn);
          host.parentNode.insertBefore(wrap, host.nextSibling);
          if (window.HFASampleBox && window.HFASampleBox.render) window.HFASampleBox.render();
          return true;
        };

        if (!injectPDP()) {
          var tries = 0;
          var iv = setInterval(function () {
            if (injectPDP() || ++tries > 24) clearInterval(iv);
          }, 250);
        }
      }

      /* (8) "Get FREE Samples" card — rewire "Order This Sample" into the
         Sample Box (see (4) in the comment block above). Replacing the node
         drops the old inline onclick (which redirected to /pages/samples);
         the box's delegated [data-sample-handle] click handler and this
         layer's variant-capture handler then treat it like any other
         sample button, and render() keeps its label in sync. */
      var rewireCard = function () {
        var olds = document.querySelectorAll('.hf-samples-btn');
        if (!olds.length) return false;
        var done = false;
        for (var i = 0; i < olds.length; i++) {
          var old = olds[i];
          if (old.hasAttribute('data-sample-handle')) { done = true; continue; }
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = old.className;
          btn.setAttribute('data-sample-handle', d.handle);
          btn.setAttribute('data-sample-title', d.title || '');
          btn.setAttribute('data-sample-image', d.image || '');
          btn.setAttribute('data-sample-sku', d.sku || '');
          if (d.variant) { btn.setAttribute('data-sample-variant', d.variant); }
          btn.setAttribute('data-label-default', 'Order This Sample');
          btn.innerHTML = '<span data-sample-label>Order This Sample</span>';
          old.parentNode.replaceChild(btn, old);
          done = true;
        }
        if (done && window.HFASampleBox && window.HFASampleBox.render) window.HFASampleBox.render();
        return done;
      };
      if (!rewireCard()) {
        var cardTries = 0;
        var cardIv = setInterval(function () {
          if (rewireCard() || ++cardTries > 24) clearInterval(cardIv);
        }, 250);
      }
    }

    if (window.HFA_PDP_SAMPLE) {
      hfaRun();
    } else if (/^\/products\/[^\/?#]+/.test(location.pathname)) {
      /* Safety net: Liquid emit missing (e.g. product not passed to this
         snippet). Pull the public product JSON — no metafields there, so
         no per-floor variant; checkout uses the box's generic $0 variant. */
      fetch(location.pathname.split('?')[0].replace(/\/$/, '') + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p || !p.handle) return;
          var tags = p.tags || [];
          if (tags.indexOf('no-sample') > -1) return;
          var img = p.featured_image || (p.images && p.images[0]) || '';
          if (img && img.indexOf('//') === 0) { img = 'https:' + img; }
          if (img) { img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=240'; }
          window.HFA_PDP_SAMPLE = {
            variant: '',
            handle: p.handle,
            title: p.title || '',
            image: img,
            sku: (p.variants && p.variants[0] && p.variants[0].sku) || ''
          };
          hfaRun();
        })
        .catch(function () {});
    }
  })();
